// http://fbdevwiki.com/wiki/Locales
export const localeMap = {
  af: 'af_ZA',
  ar: 'ar_AR',
  az: 'az_AZ',
  bg: 'bg_BG',
  bn: 'bn_IN',
  bs: 'bs_BA',
  ca: 'ca_ES',
  cs: 'cs_CZ',
  da: 'da_DK',
  de: 'de_DE',
  el: 'el_GR',
  en: 'en_US',
  'en-AU': 'en_GB',
  'en-GB': 'en_GB',
  es: 'es_LA',
  'es-AR': 'es_LA',
  'es-ES': 'es_ES',
  et: 'et_EE',
  eu: 'eu_ES',
  fi: 'fi_FI',
  'fr-CA': 'fr_FR',
  gl: 'gl_ES',
  fr: 'fr_FR',
  he: 'he_IL',
  hi: 'hi_IN',
  hr: 'hr_HR',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ka: 'ka_GE',
  kk: 'kk_KZ',
  km: 'km_KH',
  ko: 'ko_KR',
  lo: 'lo_LA',
  lt: 'lt_LT',
  lv: 'lv_LV',
  mk: 'mk_MK',
  ms: 'ms_MY',
  my: 'my_MM',
  nb: 'nb_NO',
  nl: 'nl_NL',
  pl: 'pl_PL',
  pt: 'pt_BR',
  'pt-PT': 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  sk: 'sk_SK',
  sl: 'sl_SI',
  sq: 'sq_AL',
  sv: 'sv_SE',
  sw: 'sw_KE',
  ta: 'ta_IN',
  te: 'te_IN',
  tl: 'tl_PH',
  th: 'th_TH',
  tr: 'tr_TR',
  uk: 'uk_UA',
  vi: 'vi_VN',
  'zh-Hans': 'zh_CN',
  'zh-Hant': 'zh_TW',
} as const;

/**
 * get localized string
 * @param  {String} scriptURL script URL
 * @param  {String} appLocale locale
 * @return {String}           localized URL
 */
export function getLocalizedScriptURL(scriptURL: string, appLocale: string): string {
  const AKLocale = localeMap[appLocale] || 'en_US';

  return scriptURL.replace('en_US', AKLocale);
}

export default localeMap;
